import React, { Fragment, useState } from 'react'
import axios from 'axios'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import Message from '../Components/Message/Message'
import { useNavigate } from 'react-router-dom'
import styles from './challan-detailed.module.css'
import OrderHistory from './OrderHistory'

const ChallanDetails = () => {
    const accessToken = sessionStorage.getItem('accessToken')
    const details = JSON.parse(sessionStorage.getItem('challanDetails'))
    const challanSampleData = details.result
    const parentId = details.parentId
    const [tabName, setTabName] = useState('pending')
    const [selectedChallans, setSelectedChallans] = useState([])
    const [selectedChallansNumber, setSelectedChallansNumbers] = useState([])
    const [reviewChallan, setReviewChallan] = useState(false)
    const [selectedChallan, setSelectedChallan] = useState('')
    const paidChallans = challanSampleData.filter((item) => item?.status?.toLowerCase() === 'paid')
    const unpaidChallans = challanSampleData.filter((item) => item?.status?.toLowerCase() !== 'paid')
    const [message, setMessage] = useState('')
    const [messageClass, setMessageClass] = useState('')
    const [loading, setLoading] = useState(false)
    const [orderHistory, setOrderHistory] = useState(false)
    const [challanImages, setChallanImages] = useState(false)

    const navigate = useNavigate()
    const redirectPath = () => {
        const sessionDetails = JSON.parse(sessionStorage.getItem('eChallanToken'))
        const token = sessionDetails?.token || ''
        navigate(`/challan-detailed/${token}`)
    }

    // Toggles an object in an array by unique key: adds if not present, removes if present
    const toggleObjectInArray = (obj) => {
        var arr = [...selectedChallans]
        var arr1 = [...selectedChallansNumber]
        const index = arr.findIndex((item) => item.challanNo === obj.challanNo)
        if (index === -1) {
            arr.push(obj)
            arr1.push(obj.challanNo)
        } else {
            arr.splice(index, 1)
            arr1.splice(index, 1)
        }
        setSelectedChallans(arr)
        setSelectedChallansNumbers(arr1)
    }

    // Toggle select all challans
    const toggleSelectAll = () => {
        if (selectedChallans.length === unpaidChallans.length) {
            setSelectedChallans([])
            setSelectedChallansNumbers([])
        } else {
            const challansWithAmount = unpaidChallans.filter(item => Number(item.amountChallan) !== 0);
            setSelectedChallans(challansWithAmount)
            setSelectedChallansNumbers(challansWithAmount.map((item) => item.challanNo))
        }
    }

    const fetchFunction = () => {
        setLoading(true)
        axios
            .post(`${process.env.REACT_APP_PUBLIC_CONFIG_URL}/vehicle-echallan-payment-V2`, {
                challanNumber: selectedChallansNumber,
                parentId: parentId,
                accessToken: accessToken,
            })
            .then((res) => {
                setLoading(false)
                if (res.data.code === 200) {
                    setMessageClass('success')
                    window.open(res.data.paymentUrl, '_self')
                } else {
                    setMessageClass('error')
                }
                if (res.data.nonPaidChallans.length == 0) {
                    setMessage(res.data.message)
                } else {
                    setMessage('')
                }
            })
            .catch((error) => {
                setLoading(false)
                console.error(error)
                setMessageClass('error')
                setMessage(error?.response?.data?.message || 'Something went wrong. try again later')
                setTimeout(() => {
                    setMessage('')
                }, 5000)
            })
    }

    const calculateAmount = () => {
        return selectedChallans?.reduce((sum, obj) => sum + (Number(obj.amountChallan) || 0), 0)
    }

    const calculateConvenience = () => {
        return selectedChallans?.reduce((sum, obj) => sum + (Number(obj.convenience_fee) || 0), 0)
    }

    const calculateGst = () => {
        const totalConvenience = selectedChallans?.reduce((sum, obj) => sum + (Number(obj.convenience_fee) || 0), 0)
        return totalConvenience * 0.18
    }

    // Returns the original amount before discount, given the discounted amount and discount percentage
    function getOriginalAmount(discountedAmount, discountPercent) {
        if (typeof discountedAmount !== 'number' || typeof discountPercent !== 'number') return null
        if (discountPercent >= 100) return null
        return discountedAmount / (1 - discountPercent / 100)
    }

    return (
        <Fragment>
            {message && <Message message={message} messageClass={messageClass} closeMessage={() => setMessage('')} />}
            {challanImages && (
                <div className="modal-container">
                    <div className="modal-background" onClick={() => setChallanImages()}></div>
                    <div className="modal-box">
                        <div className={styles['challan-image-box']}>
                            <h5>Challan images</h5>
                            {challanImages.map((item, i) => (
                                <div key={i} className={styles['challan-image']}>
                                    <p>Image {i + 1}</p>
                                    <img src={item} alt={`challan${i + 1}`} />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            )}
            {reviewChallan && (
                <div>
                    <div className={styles['review-challan-background']} onClick={() => setReviewChallan(false)}></div>
                    <div className={styles['review-challan']}>
                        <div className={styles['review-challan-heading']}>
                            <span>Review challan details</span>
                            <img src="../images/times.svg" alt="times" onClick={() => setReviewChallan(false)} />
                        </div>
                        <div className={styles['review-challan-cards']}>
                            {selectedChallans.map((data, index) => (
                                <div key={index} className={styles['review-challan-card']}>
                                    <div className={styles['review-challan-card-basic']}>
                                        <p>
                                            {data.detailsViolation.map((item, i) => (
                                                <span key={i}>{item.offence}</span>
                                            ))}
                                            # {data.challanNo}
                                        </p>
                                        <span className={styles['amount']}>₹{data.amountChallan + data.convenience_fee}</span>
                                        <span
                                            onClick={() => {
                                                selectedChallan === data.challanNo ? setSelectedChallan('') : setSelectedChallan(data.challanNo)
                                            }}
                                            className={`fa fa-angle-${selectedChallan === data.challanNo ? 'up' : 'down'} ${styles['icon']}`}
                                        ></span>
                                    </div>
                                    {selectedChallan === data.challanNo && (
                                        <div className={styles['review-challan-card-summary']}>
                                            <p>
                                                <span>Offense charge</span> ₹{data.amountChallan}
                                            </p>
                                            <p>
                                                <span>Compliance Fee</span>{' '}
                                                <span>
                                                    ₹{data.convenience_fee} {data.discount ? <strike>₹{getOriginalAmount(data.convenience_fee, data.discount)}</strike> : ''}
                                                </span>
                                            </p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                        <div className={styles['review-challan-footer']}>
                            <div className={styles['review-challan-calculations']}>
                                <p>
                                    <span>Total amount</span> ₹{calculateAmount()}
                                </p>
                                <p>
                                    <span>Total fees</span> ₹{calculateConvenience()}
                                </p>
                                <p>
                                    <span>Total GST (18%)</span> ₹{calculateGst()}
                                </p>
                            </div>
                            <div className={styles['review-challan-action']}>
                                <p>
                                    <span>Total amount to pay</span> ₹{calculateAmount() + calculateConvenience() + calculateGst()}
                                </p>
                                <button className="btn btn-primary" onClick={() => fetchFunction()} disabled={loading}>
                                    Pay Challan
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {orderHistory ? (
                <OrderHistory closeHistory={() => setOrderHistory(false)} />
            ) : (
                <>
                    <div className={styles['challan-header']}>
                        <div className={styles['action-buttons']}>
                            <span className={styles['back-btn']} onClick={() => redirectPath()}>
                                <img src="./images/challan-detailed/backArrow.svg" alt="edit" /> Back
                            </span>
                            <span className={styles['order-history']} onClick={() => setOrderHistory(true)}>
                                Order history
                            </span>
                        </div>
                        <div className={styles['challan-header-top']}>
                            <div>
                                <div className={styles['challan-header-owner']}>{challanSampleData[0]?.nameViolator || challanSampleData[0].nameOwner}</div>
                                <div className={styles['challan-header-vehicle']}>{challanSampleData[0]?.dlRcNumber || challanSampleData[0].rcNo}</div>
                            </div>
                            {/* <img src="../images/bike.png" alt="bike" style={{ width: 70, height: 50, objectFit: 'contain' }} /> */}
                        </div>
                        <div className={styles['challan-header-tabs']}>
                            <div className={styles[tabName === 'pending' ? 'active' : '']} onClick={() => setTabName('pending')}>
                                Pending challans
                                <span>{unpaidChallans.length}</span>
                            </div>
                            <div className={styles[tabName === 'paid' ? 'active' : '']} onClick={() => setTabName('paid')}>
                                Paid challans
                                <span>{paidChallans.length}</span>
                            </div>
                        </div>
                        <div className={styles['challan-header-summary']}>
                            <div>
                                Total challan : <b>{selectedChallans.length}</b> &nbsp; | &nbsp; Amount : <b>₹{selectedChallans?.reduce((sum, obj) => sum + (Number(obj.amountChallan) || 0), 0)}</b>
                            </div>
                            <div className="d-flex align-items-center">
                                <span onClick={() => toggleSelectAll()} className={`mr-2 fa fa-${selectedChallans.length === unpaidChallans.length ? 'check-square' : 'square-o'}`}></span>
                                <b>Select All</b>
                            </div>
                        </div>
                    </div>
                    {tabName === 'pending' && (
                        <>
                            <div className={styles['challan-cards']}>
                                {unpaidChallans.map((data, index) => (
                                    <div key={index} className={styles['challan-card']}>
                                        <div className={styles['challan-card-top']}>
                                            {
                                                (data.amountChallan===0||data.amountChallan==='0')
                                                ?<span></span>
                                                :<span onClick={() => toggleObjectInArray(data)}
                                                    className={`fa fa-${selectedChallans.findIndex((o) => o.challanNo === data.challanNo) !== -1 ? 'check-square' : 'square-o'}`}
                                                ></span>
                                            }
                                            <div className={styles['challan-card-violator']}>
                                                <span>Violator Name</span> {data?.nameViolator || data?.nameOwner}
                                            </div>
                                            <div className={styles['challan-card-violator']}>
                                                <span>Status</span> {data?.status}
                                            </div>
                                        </div>
                                        <div className={styles['challan-card-amount']}>₹{data.amountChallan}</div>
                                        <div className={styles['challan-card-id']}>
                                            # {data.challanNo}{' '}
                                            <CopyToClipboard text={data.challanNo}>
                                                <img src="../images/challan-detailed/copy.png" alt="copy" />
                                            </CopyToClipboard>
                                        </div>
                                        <div className={styles['challan-card-issued']}>
                                            <img src="../images/challan-detailed/calender.png" alt="calender" /> Issued On {data.dateChallan}
                                        </div>
                                        <div className={styles['challan-card-address']}>
                                            <img src="../images/challan-detailed/location.png" alt="location" /> {data.locationChallan}
                                        </div>
                                        <div className={styles['challan-card-violation']}>
                                            {data.detailsViolation.map((item, i) => (
                                                <p key={i}>{item.offence}</p>
                                            ))}
                                        </div>
                                        <div className={styles['challan-card-links']}>
                                            {data?.imagesChallan?.length > 0 ? (
                                                <span className={styles['challan-card-link']} onClick={() => setChallanImages(data?.imagesChallan)}>
                                                    <img src="../images/challan-detailed/challan-image.png" alt="challan" /> Challan image
                                                </span>
                                            ) : (
                                                <span></span>
                                            )}
                                            <span className={styles['challan-card-echallan']}>{data.challan_search_source}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className={styles['challan-footer']}>
                                <p>
                                    <span>Total selected</span> {selectedChallans.length} challan
                                </p>
                                {selectedChallans.length === 0 ? (
                                    <button className="btn btn-primary" disabled>
                                        Proceed to Payment
                                    </button>
                                ) : (
                                    <button className="btn btn-primary" onClick={() => setReviewChallan(true)}>
                                        Proceed to Payment
                                    </button>
                                )}
                            </div>
                        </>
                    )}
                    {tabName === 'paid' && (
                        <>
                            <div className={styles['challan-cards']}>
                                {paidChallans.map((data, index) => (
                                    <div key={index} className={styles['challan-card']}>
                                        <div className={styles['challan-card-top']}>
                                            <div className={styles['challan-card-violator']}>
                                                <span>Violator Name</span> {data.nameViolator}
                                            </div>
                                            <span></span>
                                            <div className={styles['challan-card-violator']}>
                                                <span>Status</span> {data.status}
                                            </div>
                                        </div>
                                        <div className={styles['challan-card-amount']}>₹{data.amountChallan}</div>
                                        <div className={styles['challan-card-id']}>
                                            # {data.challanNo}{' '}
                                            <CopyToClipboard text={data.challanNo}>
                                                <img src="../images/challan-detailed/copy.png" alt="copy" />
                                            </CopyToClipboard>
                                        </div>
                                        <div className={styles['challan-card-issued']}>
                                            <img src="../images/challan-detailed/calender.png" alt="calender" /> Issued On {data.dateChallan}
                                        </div>
                                        <div className={styles['challan-card-address']}>
                                            <img src="../images/challan-detailed/location.png" alt="location" /> {data.locationChallan}
                                        </div>
                                        <div className={styles['challan-card-violation']}>
                                            {data.detailsViolation.map((item, i) => (
                                                <p key={i}>{item.offence}</p>
                                            ))}
                                        </div>
                                        <div className={styles['challan-card-links']}>
                                            {data?.imagesChallan?.length > 0 ? (
                                                <span className={styles['challan-card-link']} onClick={() => setChallanImages(data?.imagesChallan)}>
                                                    <img src="../images/challan-detailed/challan-image.png" alt="challan" /> Challan image
                                                </span>
                                            ) : (
                                                <span></span>
                                            )}
                                            <span className={styles['challan-card-echallan']}>Paid on: {data.datePayment}</span>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </>
                    )}
                </>
            )}
        </Fragment>
    )
}

export default ChallanDetails
